import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { RestaurantProvider } from './providers/RestaurantContext';
import AppRoutes from './routes/AppRoutes';
import AdminRoutes from './routes/AdminRoutes';
import PaymentRoutes from './routes/PaymentRoutes';
import { isAdminDomain, isPayDomain } from './config/domain';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from './shared/ErrorBoundary';

const App: React.FC = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  if (!isInitialized) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Initializing...</p>
      </div>
    );
  }

  const RoutesComponent = isPayDomain ? PaymentRoutes : isAdminDomain ? AdminRoutes : AppRoutes;

  return (
    <ErrorBoundary>
      <Router>
        <RestaurantProvider>
          <RoutesComponent />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </RestaurantProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App;

